import React from 'react';
import { Grid } from '@mui/material';
import CardNews from '../../../../components/cards/card-news/CardNews';
import CardEvent from '../../../../components/cards/card-event/CardEvent';
import { ItemType } from '../BannerNewsAndEvents';

interface IProps {
  cols: { xl?: number; lg?: number; md?: number; sm?: number; xs: number };
  data: any;
  props?: any;
  spacing?: number;
  align?: 'center' | 'normal';
}

const NewsAndEventCardsRepeater: React.FC<IProps> = ({
  cols = { xs: 6 },
  data,
  props,
  spacing = 20,
  align = 'normal',
}: IProps) => {
  return (
    <Grid container spacing={spacing} style={{ justifyContent: align }}>
      {data?.map((data: any, i: number) => (
        <Grid item {...cols} key={i}>
          {data?.attributes?.type === ItemType.NEWS
            ? React.createElement(CardNews, { data, ...props })
            : React.createElement(CardEvent, {
              data: data.attributes,
              ...props,
            })}
        </Grid>
      ))}
    </Grid>
  );
};

export default NewsAndEventCardsRepeater;
